import React from 'react';
import cx from 'classnames';

import styles from './Flags.module.scss';

export interface Props {
  className?: Parameters<typeof cx>[0];
}

export const DE: React.FC<Props> = ({ className }) => (
  <i className={cx(styles.icon, className)}>
    <svg width={25} height={24} fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <path d='M24.5 4H.5v16h24V4z' fill='#fff' />
        <path d='M24.523 9.333H.477v5.334h24.044V9.333z' fill='#D80027' />
        <path d='M24.5 4H.5v5.333h24V4z' fill='#000' />
        <path d='M24.5 14.667H.5V20h24v-5.333z' fill='#FFDA44' />
      </g>
    </svg>
  </i>
);

DE.displayName = 'DE';
export default DE;
